module.exports = __webpack_public_path__ + "resources/img/partner-thumb-samsunglife@2x.8639a8dd.png";